import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PROPERTY_REQUEST } from "./types";

interface PropertyState {
  propertyRecords: any | null;
  propertyDetails: any | null;
  loading: boolean;
  error: any | null;
}

const propertyInitialState: PropertyState = {
  propertyRecords: null,
  propertyDetails: null,
  loading: false,
  error: null,
};

export const propertySlice = createSlice({
  name: PROPERTY_REQUEST,
  initialState: propertyInitialState,
  reducers: {
    getPropertyRecordsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getPropertyRecordsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.propertyRecords = action.payload.response;
    },
    getPropertyRecordsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getPropertyDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getPropertyDetailsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.propertyDetails = action.payload.response;
    },
    getPropertyDetailsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    resetPropertyData(state) {
      state.propertyRecords = null;
      state.propertyDetails = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getPropertyRecordsRequest,
  getPropertyRecordsSuccess,
  getPropertyRecordsFailure,
  getPropertyDetailsRequest,
  getPropertyDetailsSuccess,
  getPropertyDetailsFailure,
  resetPropertyData,
} = propertySlice.actions;
export default propertySlice.reducer;
